export enum SUPPORTED_REGION {
  AU = 'AU',
  NZ = 'NZ',
  UK = 'UK',
}
